import { Link } from 'react-router-dom';
import { seriesList } from '@/mocks/series';
import { statusInfo, formatHeat } from '@/utils/series';

const rankColors = ['text-primary-500', 'text-secondary-500', 'text-accent-500', 'text-foreground-300'];

export default function Ranking() {
  const top = [...seriesList].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto w-full max-w-6xl">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-sm font-bold tracking-wide text-primary-600">吃瓜热度趋势</p>
            <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-4xl">本周话题热度榜</h2>
          </div>
          <span className="hidden items-center gap-1 whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-500 sm:inline-flex">
            <i className="ri-timer-2-line text-accent-600"></i>
            每日 10:00 更新
          </span>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {top.map((s, i) => {
            const last = s.episodes[s.episodes.length - 1];
            return (
              <Link
                key={s.id}
                to={`/story/${s.id}`}
                className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 transition-all hover:-translate-y-0.5 hover:border-primary-200 md:gap-6 md:p-4"
              >
                <span className={`w-9 shrink-0 text-center font-heading text-3xl ${rankColors[i] || 'text-foreground-300'}`}>
                  {i + 1}
                </span>
                <div className="relative hidden h-16 w-24 shrink-0 overflow-hidden rounded-xl bg-background-200 sm:block md:h-20 md:w-32">
                  <img src={s.cover} alt={`${s.title} 排名第${i + 1}`} className="h-full w-full object-cover object-top" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-bold ${statusInfo[s.status].chip}`}>
                      {statusInfo[s.status].text}
                    </span>
                    <span className="whitespace-nowrap text-xs text-foreground-400">{s.categoryName}</span>
                    {last && (
                      <span className="hidden whitespace-nowrap rounded-full bg-background-100 px-2 py-0.5 text-xs font-medium text-foreground-500 md:inline">
                        {last.ep} · {last.title}
                      </span>
                    )}
                  </div>
                  <h3 className="mt-1 truncate text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                    {s.title}
                  </h3>
                  <p className="mt-0.5 hidden truncate text-xs text-foreground-500 md:block">{s.summary}</p>
                </div>
                <div className="flex shrink-0 flex-col items-end gap-1.5">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-600">
                    <i className="ri-fire-line text-secondary-500"></i>
                    {formatHeat(s.heat)}
                  </span>
                  <span className="whitespace-nowrap text-xs text-foreground-400">热度</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}